import React from 'react';
import PropTypes from 'prop-types';

class OrderServiceList extends React.PureComponent {

    render() {

        const {orderServices} = this.props;

        if (!orderServices || orderServices.count() === 0) {
            return null;
        }

            const groupedPackages = orderServices
            .groupBy(item => item.get('action')).sortBy(item => item.get('action')).reverse()
            .toList();

        const groupItems = (item) => {
                return item
                .groupBy(g => g.get('billingSystemCode'))
                .toList();
        };

        const getAction = (actionString) =>{
            let actionStyle = '';

            switch(actionString){
                case 'Order Add':
                actionStyle = { color: 'green' } ;
                break;
        
                case 'Order Remove':
                actionStyle =  { color: 'red'};
                break;

                case 'Account Current':
                actionStyle = { color: 'black'};
                break;

                default:
                actionStyle =  { color: 'black'};
            }

            return (
                <span style={actionStyle}>{actionString}</span>
            );
        };

        const getRows = (section) => {

            return groupItems(section).map((groupedItem, index) => {

                return (
                    <tr key={'orderService_' + index}>
                        <td>{groupedItem
                                .first()
                                .get('billingSystemCode')}
                        </td>
                        <td>{groupedItem.count()}</td>
                        <td>{groupedItem
                                .first()
                                .get('description')}</td>
                        <td>{
                            getAction(groupedItem
                                .first()
                                .get('action'))
                            }</td>
                    </tr>
                    
                );
            });

        };

        const sections = groupedPackages.map((item, index) => {
            return (

                <div key={'orderServiceSection_' + index}>
                    <h5>{item
                            .first()
                            .get('type')}</h5>
                    <table className="bordered striped">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Qty</th>
                                <th>Description</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>{getRows(item)}</tbody>
                    </table>
                </div>

            );
        });

        return (
            <div>
                {sections}
            </div>
        );
    }
}
OrderServiceList.propTypes = {
    orderServices: PropTypes.object

};
export default OrderServiceList;



// WEBPACK FOOTER //
// ./src/components/account/OrderServiceList.js